// How an asset is named on screen: tiles, rows, the player and cart entries use the same rule.

const TITLE_FIELD = "Beitragstitel";
/** YYMMDD_<camera>_…, e.g. 260604_x10_nif_waldbrand */
const FILENAME_PATTERN = /^(\d{2})(\d{2})(\d{2})_([a-z]\d+)_/i;

/** Joins tags on one line: a middle dot with non-breaking spaces. */
export const TAG_SEPARATOR = "\u00a0·\u00a0";

/** The editorial title (Beitragstitel metadata), else the title, filename or TapeID. */
export function assetTitle(asset) {
  const field = ((asset && asset.metadata) || []).filter((m) => m.label === TITLE_FIELD).pop();
  const editorial = ((field && field.value) || "").trim();
  return editorial || (asset && (asset.title || asset.name || asset.tapeID)) || "Untitled";
}

/** The file's name as ingested. */
export function assetFilename(asset) {
  return (asset && (asset.name || asset.title)) || "";
}

/** e.g. "260604_x10_waldbrand.mxf · T-0042"; each value once. */
export function assetTooltip(asset) {
  const values = [assetFilename(asset), asset && asset.tapeID].filter(Boolean);
  return [...new Set(values)].join(" · ");
}

/** [DD.MM.YY, CAMERA, CODEC] from a camera filename, else [TapeID, CODEC]. */
export function assetTags(asset) {
  const tags = [];
  const match = FILENAME_PATTERN.exec(assetFilename(asset));
  const [year, month, day, camera] = match ? match.slice(1) : [];
  if (match && Number(month) >= 1 && Number(month) <= 12 && Number(day) >= 1 && Number(day) <= 31) {
    tags.push(`${day}.${month}.${year}`, camera.toUpperCase());
  } else if (asset && asset.tapeID) {
    tags.push(asset.tapeID);
  }
  const codec = codecLabel(asset);
  if (codec) tags.push(codec);
  return tags;
}

/** The codec as tagged: upper case, any pcm_ variant as PCM. */
export function codecLabel(asset) {
  const codec = String((asset && asset.codec) || "").toUpperCase();
  return codec.startsWith("PCM_") ? "PCM" : codec;
}
